<div *ngIf="mailingSkillGroup$ | async; let mailGroup" class="mailing-group-row">
   <!-- Icon / Skill Icon -->
   <span class="sam-center skill-category-icon-container">
      <fa-icon
         *ngIf="isHeader"
         [icon]="treeItem.icon"
         [fixedWidth]="true"
         class="skill-category-icons sam-center"
      ></fa-icon>

      <span *ngIf="!isHeader">
         <samweb-skill-short-info-icon
            class="sam-center"
            [skills]="mailGroup.skills"
            [skillConfiguration]="mailGroup.skillConfiguration"
         >
         </samweb-skill-short-info-icon>
      </span>
   </span>

   <!-- Checkbox -->
   <samweb-skill-active-state-checkbox
      *ngIf="treeItem.showActiveState"
      class="sam-margin-right skill-group-checkbox"
      [brickInstanceId]="brickInstanceId"
      [userId]="userId"
      [skillGroup]="mailGroup"
      [disabled]="!(isUserLoggedOn$ | async)"
      (activeStateChanged)="changeSkillStatus(mailGroup.skills, $event)"
   >
   </samweb-skill-active-state-checkbox>

   <!-- Skill Name-->
   <samweb-text-with-overflow-tooltip
      [value]="mailGroup.skillConfiguration?.skillName | translate"
      [ngClass]="
         isHeader ? 'skill-group skill-group-header sam-resizeable skill-margin' : 'sam-resizeable skill-margin'
      "
   ></samweb-text-with-overflow-tooltip>

   <!-- Agent Counter-->
   <span class="mailing-group-row sam-flex-end">
      <span
         *ngIf="treeItem.showActiveState && isHeader"
         class="skill-group sam-center sam-margin-right sam-flex-end skill-group-header"
      >
         {{ mailGroup.loggedOnUserIds.length }}
         <fa-icon class="skill-group-icons" [icon]="agentIcon" [ngStyle]="{ opacity: isHeader ? '1' : '0' }"></fa-icon>
      </span>
      <span *ngIf="treeItem.showActiveState && !isHeader" class="skill-group sam-center sam-margin-right sam-flex-end">
         {{ mailGroup.loggedOnUserIds.length }}
         <fa-icon class="skill-group-icons" [icon]="agentIcon" [ngStyle]="{ opacity: isHeader ? '1' : '0' }"></fa-icon>
      </span>
   </span>
   <!-- Messages Counter-->
   <span
      *ngIf="(isCountVisible$ | async) && isHeader"
      class="skill-group sam-center sam-flex-end skill-group-header mail-counter"
   >
      <span *ngIf="treeItem.groupName !== inboxFolder">
         {{ messageCount$ | async }}
      </span>
      <span *ngIf="treeItem.groupName === inboxFolder">
         {{ mailGroup.waitCount }}
      </span>
      <fa-icon [icon]="envelopeIcon" class="skill-group-icons" [ngStyle]="{ opacity: isHeader ? '1' : '0' }"></fa-icon>
   </span>

   <!-- Outbox Counter-->
   <span *ngIf="(isCountVisible$ | async) && !isHeader" class="skill-group sam-center sam-flex-end mail-counter">
      <span *ngIf="treeItem.groupName !== inboxFolder">
         {{ messageCount$ | async }}
      </span>
      <span *ngIf="treeItem.groupName === inboxFolder">
         {{ mailGroup.waitCount }}
      </span>
      <fa-icon [icon]="envelopeIcon" class="skill-group-icons" [ngStyle]="{ opacity: isHeader ? '1' : '0' }"></fa-icon>
   </span>
</div>
